export const QUOTE_PEER_QUOTES_PREVIEW_LIMIT = 10;
// Peers are secondary on the quote page; past this budget the page renders without them instead of waiting on the scanner.
export const QUOTE_PEER_QUOTES_SSR_TIMEOUT_MS = 3000;
